import axios from 'axios';

export const GET_INVITED_USERS_URL = '/invitedUsers/getInvitedUsersList';
export const GET_INVITED_USERS_EXPORT_URL = '/invitedUsers/getInvitedUsersListForExcel';


export function findInvitedUsers(queryParams, cancellationHandlers) {
  return axios.get(GET_INVITED_USERS_URL, {params: queryParams, ...cancellationHandlers});
}

export function findInvitedUsersForExcel(queryParams) {
  return axios.get(GET_INVITED_USERS_EXPORT_URL, {params: queryParams});
}
